import { createFileRoute } from "@tanstack/react-router";
import { TradeGuidePage, seoHead } from "@/components/hubs/HubPages";
import { TRADE_GUIDES } from "@/lib/regionalHubs";

const DATA = TRADE_GUIDES.find((x) => x.slug === "/learn/organic-leads-colorado-contractors")!;

export const Route = createFileRoute("/learn/organic-leads-colorado-contractors")({
  head: () => seoHead("/learn/organic-leads-colorado-contractors", "Free Leads First for Colorado Contractors | Guide", "How Colorado contractors earn calls from their website, SEO, Google Maps, AI search, and social media before paying for ads.", "article"),
  component: () => <TradeGuidePage guide={DATA} />,
});
